export const inputs = [
    {
        label:"Work Email Address",
        type:"email"
    },
    {
        label:"First Name",
        type:"text"
    },
    {
        label:"Last Name",
        type:"text"
    },
    {
        label:"Mobile Phone Number",
        type:"text"
    },
    {
        label:"Job Title",
        type:"text"
    },
    {
        label:"Company Name",
        type:"text"
    }
]

export const whatList = [
    'The basic principles of Design Thinking, how it impacts businesses and why we made this HostDesign Workshop',
    'How to introduce and implement Design Thinking within your business and bring cross-functional teams together',
    'Best practice in preparing for your first session and using the Workshop Kit',
    'The benefits and simplicity of using HostDesign for the prototyping stage',
    'The basic principles of Design Thinking, how it impacts businesses and why we made this HostDesign Workshop',
    'How to introduce and implement Design Thinking within your business and bring cross-functional teams together'
]